import { Box, Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

const ArchesWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  [legacyTheme.breakpoints.up('sm')]: {
    maxWidth: 580,
  },
  [legacyTheme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    maxWidth: 'none',
  },
});

const Arch = styled('div')({
  // Desktop and Mobile common styles
  maxWidth: 342,
  backgroundColor: theme.colors.tertiary[200],
  padding: theme.spacing['8x'],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [legacyTheme.breakpoints.match('lg')]: {
    // Mobile version show rounded first and last item
    margin: '4px auto',
    borderRadius: 'none',
    '&:first-of-type': {
      borderTopLeftRadius: '50% 40%',
      borderTopRightRadius: '50% 40%',
      minHeight: 100,
      paddingTop: theme.spacing['20x'],
    },
    '&:last-child': {
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16,
    },
  },
  [legacyTheme.breakpoints.up('lg')]: {
    // Desktop version is just a simple arch
    height: '22.5rem',
    borderTopLeftRadius: '100vmax',
    borderTopRightRadius: '100vmax',
    margin: '0 15px',
    paddingTop: theme.spacing['20x'],
    overflow: 'hidden',
  },
});

type PercsContent = {
  title: string;
  paragraph: React.ReactNode;
};

type PercsTriptychProps = {
  content: [PercsContent, PercsContent, PercsContent];
};

export const PercsTriptych = ({ content }: PercsTriptychProps) => {
  return (
    <Box
      __placeContent="center center"
      backgroundColor="tertiary.100"
      display="grid"
      paddingY={{ mobile: '12x', desktop: '30x' }}
      textAlign="center"
    >
      <ArchesWrapper>
        {Object.entries(content).map(([key, { title, paragraph }]) => (
          <Arch key={key}>
            <Text __whiteSpace="pre-line" as="h3" variant="h3">
              {title}
            </Text>
            <br />
            <Text variant="body4regular">{paragraph}</Text>
          </Arch>
        ))}
      </ArchesWrapper>
    </Box>
  );
};
